import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap/dist/js/bootstrap.min.js'
import 'bootstrap/dist/js/bootstrap.bundle.min.js'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import it from 'element-plus/es/locale/lang/it'

createApp(App).use(router).use(ElementPlus, { locale: it }).mount('#app')
